//* Libraries imports
import { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";

//* Actions imports
import { logout } from "../../actions/AppActions";

//* Constants
import { URL } from "../../variables";

//* Components imports
import { CircularProgress } from "@material-ui/core";
import Search from "../ReusableComponents/Search";
import { Pagination } from "@material-ui/lab";
import { BsFillEyeFill } from "react-icons/bs";


class Inscricoes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      path: "/inscricoes/avaliar",
      loading_screen: false,
      inscricoes: [],
      pagination: {
        current_page: 1,
        last_page: 1,
      },
      search: "",
      loading_search: true,
      status_avaliacao: "", 
      password:''
    };
  }

  componentDidMount() {
    this.get_inscricoes(this.state.pagination.current_page);
  }

  get_inscricoes(page, search = "", busca = true) {
    if (busca === true) {
      if (this.state.loading_search === false) {
        this.setState({ loading_search: true });
      }
    } else if (this.state.loading_screen === false) {
      this.setState({ loading_screen: true });
    }
    const statusParam = this.state.status_avaliacao ? `&status_avaliacao=${encodeURIComponent(this.state.status_avaliacao)}` : "";
    fetch(`${URL}api/inscricoes?page=${page}&search=${encodeURIComponent(search)}${statusParam}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${this.props.token}`,
      },
    })
      .then(async (responseLog) => {
        try {
          const resp = await responseLog.json();
          if (resp.message === "Unauthenticated.") {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            this.props.logout();
            return;
          }

          if (resp.errors != null || resp.error != null || resp.result === false) {
            const errors = Object.values(resp.errors || {});
            let erro = "";
            for (let i = 0; i < errors.length; i++) {
              erro += i !== errors.length - 1 ? errors[i] + "\n" : errors[i];
            }
            console.log(erro);
            this.setState({ redirect: true });
          } else {
            const data = resp.data || {};
            const apiPagination = data.pagination || {};
            const mappedPagination = {
              current_page: apiPagination.currentPage || page || 1,
              last_page: apiPagination.totalPages || 1,
            };

            this.setState({
              loading_search: false,
              inscricoes: data.inscricoes || [],
              loading_screen: false,
              pagination: mappedPagination,
              password:data.password
            });
          }
        } catch (err) {
          this.setState({ redirect: true });
          console.log(err);
        }
      })
      .catch((err) => {
        this.setState({ redirect: true });
        console.log(err);
      });
  }

  render() {
    return (
      <div className="row">
        {this.state.redirect === true && <Redirect to={this.state.path} />}

        <div className="col-12">
          <div className="card">
            <div className="card-body" id="card">
              <h4 className="mt-0 header-title" style={{ fontSize: "1.5rem", color: "black" }}>
                Lista de Inscrições
              </h4>
              <p style={{ fontSize: "1rem", color: "black" }}>
                Aqui são listadas todas as inscrições
              </p>
              <br />
              <br />

              {/* <p>Senha atual dos candidatos: {this.state.password}</p> */}

              <div className="row">
                <div className="col-12">
                  {this.state.loading_screen === false && (
                    <div>
                      <div className="flex jcsb flex-wrap mb-4" style={{alignItems:'end'}}>
                        
                        <Search
                          placeholder={"Pesquisar por nome, e-mail ou CPF"}
                          ValueChange={(value) => {
                            clearTimeout(this.pesquisarTimeout);
                            this.pesquisarTimeout = setTimeout(() => {
                              const page = { ...this.state.pagination };
                              page.current_page = 1;
                              this.setState({ pagination: page, search: value, loading_search: true });
                              this.get_inscricoes(1, value);
                            }, 500);
                          }}
                        />

                        <div style={{ minWidth: 220 }}>
                          {/* <label htmlFor="filtro-status" style={{ fontSize: "0.9rem", color: "black", marginBottom: 4 }}>
                            Status da avaliação
                          </label> */}
                          <div style={{ position: "relative" }}>
                            <select
                              id="filtro-status"
                              className="form form-control"
                              value={this.state.status_avaliacao}
                              onChange={(e) => {
                                const value = e.target.value;
                                clearTimeout(this.filtroTimeout);
                                this.filtroTimeout = setTimeout(() => {
                                  const page = { ...this.state.pagination };
                                  page.current_page = 1;
                                  this.setState({ pagination: page, status_avaliacao: value, loading_search: true }, () => {
                                    this.get_inscricoes(1, this.state.search);
                                  });
                                }, 500);
                              }}
                              style={{
                                appearance: "none",
                                paddingRight: 32,
                                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='7' viewBox='0 0 12 7'%3E%3Cpath fill='%23333' d='M6 7L0 0h12z'/%3E%3C/svg%3E")`,
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "right 12px center",
                                backgroundSize: "12px 7px",
                                borderRadius: 6,
                                border: "1px solid #ced4da",
                                // height: 46,
                                // fontSize: "0.9rem",
                              }}
                            >
                              <option value="">Todos</option>
                              <option value="deferida">Deferida</option>
                              <option value="indeferida">Indeferida</option>
                              <option value="pendente">Pendente</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="table-rep-plugin">
                        <div className="table-responsive mb-0" data-pattern="priority-columns">
                          <table id="tech-companies-1" className="table table-striped">
                            <thead>
                              <tr>
                                <th>Nome Completo</th>
                                <th>E-mail</th>
                                <th>CPF</th>
                                <th>Status da Avaliação</th>
                                <th>Data da Avaliação</th>
                                <th>Criado em</th>
                                <th data-priority="3">Ações</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.loading_search === false &&
                                this.state.inscricoes.map((item) => (
                                  <tr key={item.id}>
                                    <td>{item.nomeCompleto}</td>
                                    <td>{item.email}</td>
                                    <td>{item.cpf}</td>
                                    <td style={{ textTransform: "capitalize", color: item.statusAvaliacao === "deferida" ? "green" : item.statusAvaliacao === "indeferida" ? "red" : item.statusAvaliacao === "pendente" ? "orange" : "inherit" }}>{item.statusAvaliacao || "-"}</td>
                                    <td>
                                      {item.dataAvaliacao
                                        ? moment(item.dataAvaliacao).format("DD/MM/YYYY HH:mm")
                                        : "-"}
                                    </td>
                                    <td>{moment(item.createdAt).format("DD/MM/YYYY HH:mm")}</td>
                                    <td>
                                      <Link to={`/inscricoes/avaliar/show/${item.id}`} onClick={(e) => e.stopPropagation()}>
                                        <span
                                          className="inline-flex align-center jcc bg-warning icon"
                                          style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                          title={"Visualizar inscrição"}
                                        >
                                          <BsFillEyeFill size={17} color="white" />
                                        </span>
                                      </Link>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      {this.state.loading_search === true && (
                        <div className="row" style={{ margin: 0 }}>
                          <div className="col-12 d-flex justify-content-center align-items-center">
                            <CircularProgress />
                          </div>
                        </div>
                      )}

                      {this.state.loading_search === false && this.state.inscricoes.length === 0 && (
                        <div className="row w-100">
                          <div className="col-12">
                            <p style={{ textAlign: "center" }}>Nenhuma inscrição encontrada</p>
                          </div>
                        </div>
                      )}

                      <Pagination
                        className={this.state.pagination.last_page === 1 ? "hide" : ""}
                        style={{ display: "flex", justifyContent: "flex-end" }}
                        count={this.state.pagination.last_page}
                        page={this.state.pagination.current_page}
                        onChange={(_, value) => {
                          const page = { ...this.state.pagination };
                          page.current_page = value;
                          this.setState({ pagination: page });
                          this.get_inscricoes(value, this.state.search);
                        }}
                      />
                    </div>
                  )}

                  {this.state.loading_screen === true && (
                    <div className="row">
                      <div
                        className="col-12 d-flex justify-content-center align-items-center"
                        style={{ marginTop: "2rem" }}
                      >
                        <CircularProgress />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapsStateToProps = (state) => ({
  user: state.AppReducer.user,
  token: state.AppReducer.token,
});

export default connect(mapsStateToProps, { logout })(Inscricoes);